import Phaser, { Scene } from 'phaser';
import { Assets } from './Assets';
import { SaveLoadManager } from './saveload/SaveLoadManager';
import { GlobalEvent } from './GlobalEvent';
import { GlobalEventType } from './Constants';
import { GameActionSave } from './Types';

class _AudioManager {

    private _currentMusicMarker: string;
    private _scene: Phaser.Scene;
    private _music: Phaser.Sound.NoAudioSound | Phaser.Sound.HTML5AudioSound | Phaser.Sound.WebAudioSound;

    private _controlledSounds: {
        marker: string,
        playDelay: number,
        lastPlayedTime: number,
        pitch: number,
        pitchChangeDelay: number
    }[] = [];

    init(scene: Scene) {
        this._scene = scene;

        this._music = this._scene.sound.addAudioSprite(Assets.AUDIOSPRITE_SOUNDS.key, { loop: true });
        this._controlledSounds = [];

        if (SaveLoadManager.GameData.muted) {
            this.mute();
        } else {
            this.unmute();
        }
    }


    public playSound(marker: string): void {
        this._scene.sound.playAudioSprite(Assets.AUDIOSPRITE_SOUNDS.key, marker, { volume: SaveLoadManager.GameData.muted ? 0 : 1 });
    }

    public playSoundControlled(marker: string, playDelay: number, pitchChange?: boolean): void {

        this._controlledSounds = this._controlledSounds.filter(c => Date.now() - c.lastPlayedTime < c.pitchChangeDelay);

        const s = this._controlledSounds.find(s => s.marker === marker);
        if (!s) {
            this._controlledSounds.push({
                marker,
                playDelay,
                lastPlayedTime: Date.now(),
                pitch: 0,
                pitchChangeDelay: pitchChange ? 1000 : playDelay
            });
            this.playSound(marker);
        } else {

            if (Date.now() - s.lastPlayedTime > s.playDelay) {
                this._scene.sound.playAudioSprite(Assets.AUDIOSPRITE_SOUNDS.key, marker, {
                    volume: SaveLoadManager.GameData.muted ? 0 : 1,
                    detune: s.pitch
                });
                s.lastPlayedTime = Date.now();
                s.pitch += 50;
            }
        }
    }

    public async playMusic(marker: string, fadeDuration: number = 500): Promise<void> {
        if (this._currentMusicMarker === marker) {
            return;
        }

        if (this._music.isPlaying) {
            await new Promise(r => {
                this._scene.add.tween({
                    targets: this._music,
                    volume: 0,
                    duration: fadeDuration,
                    onComplete: r,
                    callbackScope: this
                })
            });
            this._music.stop();
        }

        this._music.play(marker, { volume: 0 });
        await new Promise(r => {
            this._scene.add.tween({
                targets: this._music,
                volume: 1,
                duration: fadeDuration,
                onComplete: r,
                callbackScope: this
            })
        });

        this._currentMusicMarker = marker;
    }

    public mute(): void {
        this._scene.sound.setMute(true);
        SaveLoadManager.GameData.muted = true;
        const d: GameActionSave = {
            type: "GameActionSave",
            name: "mute",
        }
        GlobalEvent.emit(GlobalEventType.RUN_GAME_ACTION, d);
    }

    public unmute(): void {
        this._scene.sound.setMute(false);
        SaveLoadManager.GameData.muted = false;
        const d: GameActionSave = {
            type: "GameActionSave",
            name: "unmute",
        }
        GlobalEvent.emit(GlobalEventType.RUN_GAME_ACTION, d);
    }


}

export const AudioManager = new _AudioManager();